import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import { sortOptions } from "../../config/sorting";
import { DISJUNCTIVE_FACET_TYPE } from "../../records/FacetType";
export function baseFiltersPropTypeFactory(fs, disjunctiveFacetPropType, isFilterRequired = () => false) {
  return fs.map(f => {
    const filterValueType = f.get('custom') ? PropTypes.oneOf([...f.get('customFilters').map(cf => cf.get('value')).values()]) : PropTypes.string;
    const propType = f.get('type') === DISJUNCTIVE_FACET_TYPE ? disjunctiveFacetPropType(filterValueType) : filterValueType;
    return isFilterRequired(f) ? propType.isRequired : propType;
  }).set('sort', PropTypes.oneOf(sortOptions.keySeq().toJS()));
}
export function filtersPropTypeFactory(fs, isFilterRequired = () => false) {
  return baseFiltersPropTypeFactory(fs, fvt => ImmutablePropTypes.setOf(fvt), isFilterRequired);
}
export function unenhancedPropTypeFactory(fs, isFilterRequired = () => false) {
  return baseFiltersPropTypeFactory(fs, fvt => PropTypes.oneOfType([fvt, ImmutablePropTypes.setOf(fvt)]), isFilterRequired);
}